import { Injectable } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { WebSocketSubject } from 'rxjs/webSocket';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  private socket$!: WebSocketSubject<any>;

  constructor() {}

  connect(url: string): Observable<any> {
    if (!this.socket$ || this.socket$.closed) {
        this.socket$ = new WebSocketSubject(url);
    }
    return this.socket$.asObservable().pipe(
        catchError((error) => {
            console.error("Error al conectar al WebSocket", error);
            setTimeout(() => this.connect(url), 5000);  // Reintento en 5 segundos
            return of(null);  // Devuelve un observable vacío en caso de error
        })
    );
}


  sendMessage(message: any): void {

    if (this.socket$ && !this.socket$.closed) {
        this.socket$.next(message);
    } else {
        console.error('WebSocket está cerrado, no se puede enviar mensaje');
    }
  }

  close(): void {
    this.socket$.complete();
  }
}
